/* global jQuery */
/**
* File header-search.js
*
* Handle search toggles.
*/
window.headerSearch = {};
( function( window, $, app ) {

	let searchIsOpen = false;

	// Constructor.
	app.init = function() {
		app.cache();

		if ( app.meetsRequirements() ) {
			app.bindEvents();
		}
	};

	// Cache all the things.
	app.cache = function() {
		app.$c = {
			headerSearchToggle: document.querySelector( '.site-header__search-toggle' ),
			headerSearch: document.querySelector( '.site-header__search' ),
		};

		app.$c.headerSearchInput = app.$c.headerSearch.querySelector( '.search-field' );
	};

	// Combine all events.
	app.bindEvents = function() {
		app.$c.headerSearchToggle.addEventListener( 'click', app.handleSearchToggle );

		if ( null !== app.$c.headerSearchInput ) {
			app.$c.headerSearchInput.addEventListener( 'blur', app.closeSearch );
			app.$c.headerSearchInput.addEventListener( 'focus', app.focusSearch );
		}

		window.addEventListener( 'keydown', app.escCloseSearch );
	};

	// Do we meet the requirements?
	app.meetsRequirements = function() {
		return null !== app.$c.headerSearch;
	};

	app.handleSearchToggle = function() {
		if ( searchIsOpen ) {
			app.closeSearch();
		} else {
			app.openSearch();
		}
	};

	app.openSearch = function() {
		document.body.classList.add('header-search-open');

		app.$c.headerSearchToggle.setAttribute('aria-expanded', true);
		app.$c.headerSearchInput.focus();

		searchIsOpen = true;
	};

	app.closeSearch = function() {
		if ( app.$c.headerSearchInput.value === '' ) {
			document.body.classList.remove( 'header-search-open' );
			app.$c.headerSearchToggle.setAttribute( 'aria-expanded', false );

			searchIsOpen = false;

			app.$c.headerSearch.classList.remove( 'has-focus' );
		}
	};

	app.focusSearch = function() {
		app.$c.headerSearch.classList.add( 'has-focus' );
	};

	app.escCloseSearch = function( e ) {
		if ( searchIsOpen ) {
			if (27 === e.keyCode) {
				app.closeSearch();
			}
		}
	};

	// Engage!
	$( app.init );

}( window, jQuery, window.headerSearch ) );
